import React, { useMemo } from 'react';
import { compose } from 'recompose';
import { ObjectShim } from '@packages/helpers/core/shims/object-shim';
import { Column } from '../../../components/layout/grid';
import { Footer } from '../../../components/layout/page-footer';
import { Header } from '../../../components/layout/page-header';
import { Spacer } from '../../../components/layout/spacers';
import { withMetaTags } from '../../../components/meta-tags';
import { Template } from '../../../components/template';
import { ConfigService } from '../../../services/config-service';
import { withBarrier } from '../../barrier';
import { withMarketingListData } from '../hocs/with-marketing-data';
import { Section } from './components/sections';
import { AccountActions } from './components/account-actions';
import { AccountInfo } from './components/account-info';

const Component = () => {
  const {
    MAIN: { title, subtitle, mainButtons, sectionType, pageHeader: configHeader }
  } = ConfigService.get('ACCOUNT', {});

  const pageHeader = useMemo(() => {
    const oldConfig = { heading: title, subheading: subtitle };

    return ObjectShim.mergeDeep(oldConfig, configHeader);
  }, [title, subtitle, configHeader]);

  return (
    <>
      <Header
        heading={pageHeader?.heading}
        subheading={pageHeader?.subheading}
        category={pageHeader?.category}
        image={pageHeader?.image}
        type={pageHeader?.type}
        backgroundPosition={pageHeader?.backgroundPosition}
        withKeyline
      />
      <Template>
        <Spacer type='top' />
        <Column>
          <AccountInfo />
        </Column>
        <Column>
          <Section name={sectionType} items={mainButtons} />
        </Column>
        <Spacer />
        <Column>
          <AccountActions />
        </Column>
        <Spacer type='bottom' />
      </Template>
      <Footer pageType='account' />
    </>
  );
};

const SEO_PAGE_DATA_NAME = 'default';

export const Account = compose(withBarrier, withMarketingListData, withMetaTags(SEO_PAGE_DATA_NAME))(Component);
